module.exports = __webpack_public_path__ + "media/images/book-61c2e769bae368178eb049c28cc35eb0.jpg";